import React from 'react';
import { Link } from 'react-router-dom';

const ContactPage = () => {
  const committeeMembers = [
    {
      name: 'Shiv Kumar',
      position: 'President',
      phone: '8081005060',
      color: 'from-blue-500 to-blue-700'
    },
    {
      name: 'T. P. Singh',
      position: 'Vice President',
      phone: '9423063957',
      color: 'from-purple-500 to-purple-700'
    },
    {
      name: 'Ajay',
      position: 'Secretary',
      phone: '9555683127',
      color: 'from-green-500 to-green-700'
    },
    {
      name: 'Ashish Awasthi',
      position: 'Treasurer',
      phone: '7800839108',
      color: 'from-amber-500 to-amber-700'
    },
    {
      name: 'Arvindra Mishra',
      position: 'Member',
      phone: '9415005878',
      color: 'from-pink-500 to-pink-700'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <Link to="/" className="text-blue-600 hover:text-blue-800 flex items-center bg-white py-2 px-4 rounded-full shadow-md hover:shadow-lg transition-all duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
            Back to Home
          </Link>
        </div>

        {/* Page Title */}
        <div className="text-center mb-10">
          <div className="inline-block bg-white rounded-2xl shadow-xl p-8 mb-6">
            <h1 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">Contact Management</h1>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full my-4"></div>
            <p className="text-gray-600">Get in touch with the Sapna Enclave management committee</p>
          </div>
        </div>

        {/* Committee Members */}
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-center mb-8">
            <div className="h-1 bg-gradient-to-r from-transparent via-gray-300 to-transparent flex-grow"></div>
            <h2 className="text-2xl font-bold text-gray-800 px-6 bg-white py-2 rounded-full shadow-md mx-4">Management Committee</h2>
            <div className="h-1 bg-gradient-to-r from-transparent via-gray-300 to-transparent flex-grow"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {committeeMembers.map((member, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl group"
              >
                <div className={`h-3 bg-gradient-to-r ${member.color}`}></div>
                <div className="p-6">
                  <div className="flex items-center mb-6">
                    <div className={`bg-gradient-to-r ${member.color} rounded-full p-4 mr-4 text-white shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-800">{member.name}</h3>
                      <p className={`text-transparent bg-clip-text bg-gradient-to-r ${member.color} font-semibold`}>{member.position}</p>
                    </div>
                  </div>
                  
                  <div className="mt-6">
                    <a 
                      href={`tel:${member.phone}`} 
                      className="flex items-center justify-center w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold py-3 px-4 rounded-lg transition-colors group-hover:shadow-md"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      {member.phone}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="max-w-4xl mx-auto mt-16">
          <div className="flex items-center justify-center mb-8">
            <div className="h-1 bg-gradient-to-r from-transparent via-gray-300 to-transparent flex-grow"></div>
            <h2 className="text-2xl font-bold text-gray-800 px-6 bg-white py-2 rounded-full shadow-md mx-4">Send a Message</h2>
            <div className="h-1 bg-gradient-to-r from-transparent via-gray-300 to-transparent flex-grow"></div>
          </div>
          
          <div className="bg-white rounded-xl shadow-xl p-8 border-t-4 border-blue-600">
            <form>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 font-semibold mb-2">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    placeholder="John Doe"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    placeholder="john@example.com"
                  />
                </div>
              </div>
              
              <div className="mb-6">
                <label htmlFor="subject" className="block text-gray-700 font-semibold mb-2">Subject</label>
                <input
                  type="text"
                  id="subject"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="How can we help you?"
                />
              </div>
              
              <div className="mb-6">
                <label htmlFor="message" className="block text-gray-700 font-semibold mb-2">Message</label>
                <textarea
                  id="message"
                  rows="5"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="Write your message here..."
                ></textarea>
              </div>
              
              <div className="text-center">
                <button
                  type="submit"
                  className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-bold py-3 px-8 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-500 text-sm">
              <p>© 2025 Sapna Enclave Residential Society. All rights reserved.</p>
            </div>
            <div className="text-gray-500 text-sm">
              <p>Maintained by <a href="https://futuresofttech.in" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 transition-colors font-medium">Futuresoft Tech</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
